import { render, staticRenderFns } from "./StatusGroup.vue?vue&type=template&id=54bb4020"
import script from "./StatusGroup.vue?vue&type=script&lang=js"
export * from "./StatusGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports